// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3L83M","buttons":"Footer_buttons__1uTFM"};